import { queryClient } from "../filter/prefetcher";
import { useMutation, useQuery } from "@tanstack/react-query";
const fetchData = async (props) => {
    try {
        let queryUrl = '';
        queryUrl = process.env.NODE_ENV === 'development' ? '/api/gatsby-plugin-atollon/go' : '/go';
        if (queryUrl) {
            return fetch(queryUrl, {
                method: props?.verb || 'GET',
                body: props?.data ? JSON.stringify(props.data) : undefined
            }).then(res => res.json());
        }
    }
    catch (e) {
        return null;
    }
    return null;
};
const useUser = () => {
    const mutation = useMutation({
        mutationKey: ['user'],
        mutationFn: async (props) => {
            const endpointData = await fetchData(props);
            if (endpointData.reason) {
                throw new Error(`${endpointData.message} - ${endpointData.reason}`);
            }
            if (endpointData) {
                return endpointData.meta?.user || null;
            }
            return null;
        },
        onSuccess: data => {
            queryClient.setQueryData(['user'], data);
        }
    }, queryClient);
    const { isLoading, error, data: foundData } = useQuery({
        queryKey: ['user'],
        queryFn: async () => {
            const endpointData = await fetchData();
            if (endpointData.reason) {
                throw new Error(`${endpointData.message} - ${endpointData.reason}`);
            }
            if (endpointData) {
                return endpointData.meta?.user || null;
            }
            return null;
        },
        refetchInterval: 60000 * 2 // 5 mins
        // re-fetch interval
    }, queryClient);
    const updateUser = (data) => {
        mutation.mutate({ verb: 'PUT', data });
    };
    const signOut = () => {
        mutation.mutate({ verb: 'DELETE' });
    };
    return {
        id: foundData?.id,
        data: foundData?.data || null,
        email: foundData?.email || null,
        firstName: foundData?.firstName || null,
        lastName: foundData?.lastName || null,
        loading: isLoading,
        authenticated: !!(foundData?.authenticated),
        error: error?.message || null,
        updateUser,
        signOut
    };
};
export default useUser;
//# sourceMappingURL=use-user.js.map